import { Box, FormControl, FormLabel, IconButton, Tooltip } from '@mui/material';
import { FC } from 'react';
import { ClientJobFunctionSelect } from '../../../../../../Components/CommonInputs';
import { FormInput } from '../../../../../../Components/CoreLib/library';
import { TextFieldWithDataReferences } from '../../../../../../Components/Wysiwyg';
import { ClientJobFunctionDto, StepDto } from '../../../../../../dtos';
import { JobFunctionQuickAddButton } from '../../../../../JobFunction/Components';
import { SmartValueListItem } from './SmartValueSlice';
import { Help } from '@mui/icons-material';

export interface IEditStepAssignmentInputProps {
    isExternalStep: boolean;
    fieldErrors: Map<keyof StepDto, string>;
    externalRoleName: string;
    handleExternalRoleNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    internalJobFunctionId: string;
    handleInternalJobFunctionChange: (updatedJobFunction: ClientJobFunctionDto | undefined) => void;
    tag: string;
    handleTagChange: (tag: string) => void;
    smartValues: SmartValueListItem[];
}

export const EditStepAssignmentInput: FC<IEditStepAssignmentInputProps> = ({
    isExternalStep,
    fieldErrors,
    externalRoleName,
    handleExternalRoleNameChange,
    internalJobFunctionId,
    handleInternalJobFunctionChange,
    tag,
    handleTagChange,
    smartValues
}) => {

    if (isExternalStep) {
        return (
            <FormInput
                value={externalRoleName}
                onChange={handleExternalRoleNameChange}
                label='Role Name'
                name='roleName'
                errorText={fieldErrors.get('externalRoleName')}
                fullWidth
                required
            />
        )
    } else {
        return (
            <Box display='flex' flexWrap='nowrap' gap={1} alignItems='end'>
                <ClientJobFunctionSelect
                    selectedJobFunctionId={internalJobFunctionId}
                    handleSelectedJobFunctionChange={handleInternalJobFunctionChange}
                    errorMessage={fieldErrors.get('internalJobFunctionId')}
                    required
                />
                <Box pb={1.5}>
                    <JobFunctionQuickAddButton onNewJobFunctionAdded={handleInternalJobFunctionChange} />
                </Box>
                <FormControl sx={{ width: 400 }}>
                    <Box>
                        <FormLabel>Tag</FormLabel>
                        <Tooltip title="The tag is used to filter down which users in a Job Function can be assigned to this step.">
                            <IconButton>
                                <Help />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <TextFieldWithDataReferences initialValue={tag} onChange={handleTagChange} dataReferences={smartValues.map(sv => sv.value)} />
                </FormControl>
            </Box>
        )
    }
}